import { render, staticRenderFns } from "./Detailpm.vue?vue&type=template&id=effca1d0&scoped=true"
import script from "./Detailpm.vue?vue&type=script&lang=js"
export * from "./Detailpm.vue?vue&type=script&lang=js"
import style0 from "./Detailpm.vue?vue&type=style&index=0&id=effca1d0&prod&lang=scss"
import style1 from "./Detailpm.vue?vue&type=style&index=1&id=effca1d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effca1d0",
  null
  
)

export default component.exports